import { handleActions } from 'redux-actions'
import {
  SET_ACTIVE_ACCOMMODATION,
  ADD_ACTIVE_ACCOMMODATIONS,
  RESET_ACTIVE_ACCOMMODATION,
  SET_ACTIVE_RETURN_ACCOMMODATIONS,
  SET_ACTIVE_DEPARTURE_ACCOMMODATIONS
} from './constants'

const activeAccommodationsInitialState = {
  departure: {},
  return: {}
}

const activeAccommodationsReducer = handleActions(
  {
    [SET_ACTIVE_ACCOMMODATION]: (state, action) => {
      const accommodation = {
        ...state[action.payload.direction],
        [action.payload.code]: {
          count: action.payload.count,
          details: action.payload.accommodation
        }
      }
      const accommodationCount = action.payload.count
      // accommodation reset to {} when count is 0
      const accommodationByCount = accommodationCount ? accommodation : {}
      return {
        ...state,
        [action.payload.direction]: accommodationByCount
      }
    },
    [ADD_ACTIVE_ACCOMMODATIONS]: (state, action) => {
      const copy = { ...state }
      copy.departure = {
        ...copy.departure,
        ...action.payload.departure
      }
      copy.return = {
        ...copy.return,
        ...action.payload.return
      }
      return copy
    },
    [SET_ACTIVE_DEPARTURE_ACCOMMODATIONS]: (state, action) => {
      return {
        ...state,
        departure: action.payload
      }
    },
    [SET_ACTIVE_RETURN_ACCOMMODATIONS]: (state, action) => {
      return {
        ...state,
        return: action.payload
      }
    },
    [RESET_ACTIVE_ACCOMMODATION]: () => ({
      ...activeAccommodationsInitialState
    })
  },
  { ...activeAccommodationsInitialState }
)

export { activeAccommodationsInitialState }
export default activeAccommodationsReducer
